import { makeStyles } from '@material-ui/core/styles'
import { CALLOUT_BACKGROUND, CALLOUT_FOREGROUND } from 'lib/form-field-styles'
import {
  SEGMENTED_BUTTON_BORDER,
  SEGMENTED_BUTTON_BORDER_RADIUS,
  SEGMENTED_BUTTON_PADDING_X,
  SEGMENTED_BUTTON_PADDING_Y,
} from 'lib/segmented-button-styles'

const useStyles = makeStyles(theme => ({
  tabWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    boxSizing: 'border-box',
    minHeight: 48,
    borderBottom: `1px solid ${theme.palette.divider}`,
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },
  segmentControl: {
    alignSelf: 'flex-start',
    flex: '0 0 auto',
    width: 280,
    minWidth: 280,
    overflow: 'hidden',
    alignItems: 'stretch',
    borderRadius: SEGMENTED_BUTTON_BORDER_RADIUS,
    border: `1px solid ${SEGMENTED_BUTTON_BORDER}`,
    backgroundColor: '#FFFFFF',
    '& .MuiToggleButton-root': {
      minWidth: 0,
      flex: '1 1 50%',
      width: '50%',
      maxWidth: '50%',
      alignSelf: 'stretch',
      padding: `${SEGMENTED_BUTTON_PADDING_Y}px ${SEGMENTED_BUTTON_PADDING_X}px`,
      borderRadius: 0,
      border: 'none',
      margin: 0,
      color: CALLOUT_FOREGROUND,
      backgroundColor: '#FFFFFF',
      textTransform: 'none',
      fontWeight: 400,
      '& .MuiToggleButton-label': {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
      },
      '&:not(:first-of-type)': {
        borderLeft: `1px solid ${SEGMENTED_BUTTON_BORDER}`,
        marginLeft: 0,
      },
      '&:hover': {
        backgroundColor: '#FFFFFF',
      },
      '&.MuiToggleButton-sizeSmall': {
        padding: `${SEGMENTED_BUTTON_PADDING_Y}px ${SEGMENTED_BUTTON_PADDING_X}px`,
      },
      '&.Mui-selected': {
        padding: `${SEGMENTED_BUTTON_PADDING_Y}px ${SEGMENTED_BUTTON_PADDING_X}px`,
        backgroundColor: CALLOUT_BACKGROUND,
        color: CALLOUT_FOREGROUND,
        '&:hover': {
          backgroundColor: CALLOUT_BACKGROUND,
        },
      },
      '&.MuiToggleButton-sizeSmall.Mui-selected': {
        padding: `${SEGMENTED_BUTTON_PADDING_Y}px ${SEGMENTED_BUTTON_PADDING_X}px`,
      },
      '&:first-of-type': {
        borderTopLeftRadius: SEGMENTED_BUTTON_BORDER_RADIUS,
        borderBottomLeftRadius: SEGMENTED_BUTTON_BORDER_RADIUS,
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
      },
      '&:last-of-type': {
        borderTopRightRadius: SEGMENTED_BUTTON_BORDER_RADIUS,
        borderBottomRightRadius: SEGMENTED_BUTTON_BORDER_RADIUS,
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
      },
    },
  },
  showCancellations: {
    flexShrink: 0,
    margin: 0,
    [theme.breakpoints.down('xs')]: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  },
  containerStyles: {
    [theme.breakpoints.down('xs')]: {
      padding: '0',
      marginBottom: '60px',
    },
  },
  base: {
    background: '#e9f5fe',
    borderRadius: '10px',
    padding: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  divider: {
    margin: '0 16px',
    background: 'e9f5fe',
    color: 'e9f5fe',
  },
  logo: {
    width: '50px',
    minWidth: '50px',
    alignSelf: 'center',
  },
  body: {
    padding: '16px 16px',
  },
  button: {
    minWidth: '150px',
  },
  disabledButton: {
    background: '#0000001F',
    color: '#00000042',
    '&:hover': {
      background: '#0000001F',
    },
  },
  errorIcon: {
    color: '#000000DE',
  },
  unableToAcceptPaymentsChip: {
    position: 'absolute',
    background: '#F88078',
    top: '45px',
    right: '5px',
  },
  payoutsOnHoldChip: {
    position: 'absolute',
    background: '#FFB547',
    top: '45px',
    right: '5px',
  },
}))

export default useStyles
